import React from 'react';
import ServiceHero from '../../../components/service/ServiceHero';
import QuoteForm from '../../../components/home/QuoteForm';
import ServiceTrusted from '../../../components/service/ServiceTrusted';
import DesireTechSection from '../../../components/home/DesireTechSection';
import ServiceArchitecture from '../../../components/service/ServiceArchitecture';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import ModelsSection from '../../../components/home/ModelsSection';
import ServiceHiring from '../../../components/service/ServiceHiring';
import ServiceChoose from '../../../components/service/ServiceChoose';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import AwardsSection from '../../../components/home/AwardsSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';
import ServiceOurMapBim from '../../../components/service/ServiceOurMapBim';

const MepBimServicesPage = () => {
  const mepSteps = [
    {
      title: "Loading MEP BIM Template",
      description: "We start by loading the MEP BIM template, customized to meet the client's standards for mechanical, electrical, plumbing, sanitary, and fire protection trades. This template provides a framework for consistent and accurate coordination."
    },
    {
      title: "Verifying the Architectural Model",
      description: "Before linking the Architectural model with the MEP models, we thoroughly verify and check their coordination. By using the 'Origin to Origin' positioning approach, we ensure proper alignment and integration between the architectural and MEP elements."
    },
    {
      title: "Preparing the MEP Model",
      description: "Next, we prepare the MEP model for each discipline, including Mechanical, Electrical, and Plumbing. All relevant elements for coordination are included within the central file, ensuring comprehensive representation and accurate coordination."
    },
    {
      title: "Running Clash Detection",
      description: "Using Navisworks, we coordinate the MEP models together, allowing us to identify clashes and conflicts between the coordinated elements. By running a clash detection test, we generate a detailed 'Clash Report' that highlights clashes within the model."
    },
    {
      title: "Reviewing & Resolving Clashes",
      description: "After identifying clashes, we proceed to review and resolve them. By reloading the cache in Navisworks, we ensure that the resolved clashes are indicated in yellow, indicating successful resolution. We also check for any new clashes, which are displayed in red, allowing us to address them promptly."
    }
  ];

  const mepFaqs = [
    {
      question: "What Are The Benefits Of Outsourcing MEP BIM Services?",
      answer: "Outsourcing MEP BIM services allows you to access specialized expertise, reduce overhead costs, and ensure high-quality coordination. It streamlines project timelines and minimizes on-site errors through proactive clash detection."
    },
    {
      question: "What Does MEP BIM Include?",
      answer: "MEP BIM includes 3D modeling of Mechanical (HVAC), Electrical, and Plumbing systems. It also covers fire protection, coordination, clash detection, shop drawings, and quantity take-offs."
    },
    {
      question: "How Does MEP BIM Help Reduce Clashes On-Site?",
      answer: "By creating a coordinated 3D model, we can identify and resolve conflicts between MEP systems and other disciplines (structural, architectural) before construction begins, preventing costly rework."
    },
    {
      question: "Can You Deliver Fabrication-Ready Shop Drawings?",
      answer: "Yes, we provide detailed fabrication and installation shop drawings directly from coordinated BIM models, including spool drawings and precise dimensions for accurate shop fabrication."
    },
    {
      question: "Do You Support Energy Modeling And Performance Analysis?",
      answer: "Absolutely. We offer energy modeling and performance analysis services to optimize building efficiency, supporting sustainability goals and LEED certification requirements."
    }
  ];

  return (
    <div className="mep-bim-services-page">
      <style jsx>{`
        .mep-bim-services-page :global(.desire-tech-subtitle) {
          max-width: 870px !important;
        }
        .mep-bim-services-page :global(.service-architecture) {
          padding: 20px 20px !important;
        }
        .mep-bim-services-page :global(.architecture-header) {
          margin-bottom: 25px !important;
        }
        .mep-bim-services-page :global(.architecture-card) {
          padding: 25px 15px !important;
          border: 5px solid #54b248 !important;
        }
        .mep-bim-services-page :global(.architecture-card h3) {
          margin: 0 !important;
        }
        .mep-bim-services-page :global(.card-icon) {
          margin-bottom: 15px !important;
        }
        .mep-bim-services-page :global(.faq-title) {
          margin-bottom: 30px !important;
        }
      `}</style>
      <ServiceHero
        overline="REACTJS DEVELOPMENT COMPANY"
        className="mep-hero"
        staticTitle={<> <span className="text-primary">Outsource MEP BIM Services in</span> USA For <br /> Accurate & Efficient Project Delivery</>}
        description={<>
          Providing excellence through a personalized service which results in a high percentage of repeat business. <br />
          We offer CAD services outsourcing for Mechanical, Electrical, Plumbing (MEP) BIM Services including MEP coordination drawings, MEP Shop Drawings
        </>}
        buttonText="Hire react developers now"
        typingWords={[]}
      />
      <QuoteForm />
      <ServiceTrusted
        title={<><span className="text-primary">MEP BIM</span> Modeling Services</>}
        paragraphs={[
          "We deliver intelligent, data-rich MEP BIM models from 2D drawings, point clouds, or PDFs to support mechanical, electrical, and plumbing engineers. Our BIM services enhance system coordination, detect clashes early, and streamline project planning and execution—ensuring precision, reduced rework, and improved efficiency throughout every stage of your MEP projects.",
          "As a leading BIM service provider, we specialize in delivering comprehensive building information modeling (BIM) services tailored for mechanical, plumbing, and electrical (MEP) systems, serving the needs of MEP contractors, fabricators, and general contractors.",
          "Our accurately generated and clash-free BIM models help improved collaboration amongst various parties involved in the construction process. Our expertise in MEP BIM projects enable early identification and resolution of conflicts.",
          "Chudasama Outsourcing has been fortunate to collaborate with major MEP engineering firms and contractors, gaining valuable experience along the way. We have provided standalone and integrated BIM modeling services to complex building projects such as medical laboratories, hospitals, correctional facilities and power plants."
        ]}
        buttonText="Book a Meeting"
      />
      <ServiceOurMapBim />
      <DesireTechSection
        title={<><span className="text-primary">Let's Discuss Your</span> MEP BIM Projects</>}
        subtitle="Planning a project and need clear MEP coordination? Get in touch with us to go over your requirements and next steps."
        buttonText="Book a Free Consultation"
      />
      <ServiceArchitecture
        title={<>Our <span className="text-primary">MEP BIM</span> Coordination Process</>}
        description="As a professional bim modeling company in USA, we have a highly skilled BIM team to develop MEP BIM Modeling solutions and our well-established methodology comprises the following phases."
        steps={mepSteps}
      />
      <ProjectsSection />
      <TestimonialsSection />
      <ModelsSection />
      <ServiceHiring />
      <ServiceChoose
        title={<> <span className="text-primary">How to Choose the Right MEP BIM Services</span> Company for Your Building & Construction Projects</>}
        subtitle="The benefits of MEP BIM Services in the construction process are numerous. Here are the key advantages of MEP coordination, clash detection, and shop drawing outsourcing."
        points={[
          {
            title: "MEP BIM Expertise",
            desc: "Our MEP BIM models are delivered by experienced engineers skilled in Autodesk Revit MEP, Navisworks, and industry-standard coordination workflows."
          },
          {
            title: "Clash-Free Coordination",
            desc: "We provide accurate MEP clash detection and coordination, eliminating conflicts between Mechanical, Electrical, & Plumbing systems before construction begins."
          },
          {
            title: "Focus on Core Work",
            desc: "Leave the complexity of MEP BIM modeling to our experts while your team focuses on design decisions, client management, and on-site execution."
          },
          {
            title: "Latest BIM Technology",
            desc: "We use the latest Autodesk Revit MEP, AutoCAD MEP, and Navisworks software to deliver high-performance models with maximum accuracy and LOD compliance."
          },
          {
            title: "Scalable for Any Project",
            desc: "Our MEP BIM services scale seamlessly from small residential fit-outs to large commercial, industrial, and infrastructure projects of any size and complexity."
          },
          {
            title: "Seamless Collaboration",
            desc: "Our team works as a direct extension of yours — coordinating with architects, structural engineers, contractors, and all MEP stakeholders for smooth project delivery."
          },
          {
            title: "Faster Turnaround",
            desc: "Our turnaround time for MEP BIM projects is faster with the help of advanced tools, streamlined workflows, and dedicated project managers who help meet your deadlines."
          },
          {
            title: "Global Reach",
            desc: "We serve clients across the USA, UK, UAE, Canada, and Australia, delivering MEP BIM services with full compliance to international standards and project requirements."
          }
        ]}
      />
      <BestArchitectureSection />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection
        title={<><span className="text-primary">MEP BIM</span> Services FAQ</>}
        faqs={mepFaqs}
      />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default MepBimServicesPage;
